export default __webpack_public_path__ + "bc05ad90f1acf09eb5901a33af9915e0.png";